module.exports = __webpack_public_path__ + "img/weixin@2x.c7dc8b3a.png";